/**
 * @flow
 * @relayHash d894ba018d348f681aadaf8afe358ed1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentSections = "BRAND" | "DESCRIPTION" | "EVENT_SEGMENTS" | "FORM" | "LINE_ITEMS" | "NOTES" | "PAYMENT_PLAN" | "PLAYLISTS" | "RECIPIENT" | "SIGNATURE_BLOCKS" | "TERMS" | "%future added value";
export type CreateContractInput = {
  clientMutationId?: ?string,
  title: string,
  terms?: ?string,
  workspace_ids: $ReadOnlyArray<?string>,
  copy_user_event_segments: boolean,
  copy_document?: ?CopyDocumentInput,
  brand_id?: ?string,
  add_default_signature_block?: ?boolean,
  c_template_id?: ?string,
};
export type CopyDocumentInput = {
  document_id?: ?string,
  include_only?: ?$ReadOnlyArray<?DocumentSections>,
  exclude?: ?$ReadOnlyArray<?DocumentSections>,
};
export type NewDocument_CreateContractMutationVariables = {|
  input: CreateContractInput
|};
export type NewDocument_CreateContractMutationResponse = {|
  +createContract: ?{|
    +contract: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type NewDocument_CreateContractMutation = {|
  variables: NewDocument_CreateContractMutationVariables,
  response: NewDocument_CreateContractMutationResponse,
|};
*/


/*
mutation NewDocument_CreateContractMutation(
  $input: CreateContractInput!
) {
  createContract(input: $input) {
    contract {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createContract",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateContractInput!"
      }
    ],
    "concreteType": "CreateContractPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contract",
        "storageKey": null,
        "args": null,
        "concreteType": "Contract",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "NewDocument_CreateContractMutation",
  "id": null,
  "text": "mutation NewDocument_CreateContractMutation(\n  $input: CreateContractInput!\n) {\n  createContract(input: $input) {\n    contract {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NewDocument_CreateContractMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "NewDocument_CreateContractMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8ab28d3c554367b191c7c0da2a91a46b';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/NewDocument_CreateContractMutation.graphql.js